<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	// Stores
	import ACLStore from '@/Stores/ACLStore.js';
	import SportcastSelectionStore from '@/Stores/Sport/SportcastSelectionStore.js';
	// Constants
	import { SportSelectionStatus } from '@/Constants/SportSelection.js';
	// Components
	import Modal from '@/Components/ModalFlex.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let selection_id;
	export let eventName;
	export let open = false;

	const dispatch = createEventDispatcher();

	let errors;
	let sending = false;
	let sgmSelections = [];

	$: selection = selection_id && $SportcastSelectionStore && $SportcastSelectionStore.firstWhere('id', selection_id);
	$: selection_id && SportcastSelectionStore.getSportcastSelection(selection_id);
	$: selection && getSGMSelections();

	function getSGMSelections() {
		if (!selection) return;
		if (sgmSelections.length > 0) return;

		const selections = [];
		for (const sgm_selection of selection.remote_selections) {
			selections.push({
				id: sgm_selection.id,
				name: sgm_selection.name,
				status:
					sgm_selection?.status &&
					sgm_selection?.status?.id &&
					parseInt(sgm_selection.status.id) === SportSelectionStatus.Active
						? false
						: sgm_selection?.status?.id
							? parseInt(sgm_selection?.status?.id)
							: false
			});
		}

		sgmSelections = selections;
	}

	window.scrollTo(0, 0);

	function saveResults() {
		let allStatusesSet = true;
		errors = {};
		// Drop the name from the payload
		const selectionResults = { remote_selections: [] };
		for (const sgmSelection of sgmSelections) {
			if (sgmSelection.status == false) {
				allStatusesSet = false;
				errors[sgmSelection.id + '-status'] = ['Result is required'];
			}
			selectionResults.remote_selections.push({
				id: sgmSelection.id,
				status_id: sgmSelection.status
			});
		}

		if (allStatusesSet == false) {
			notify({
				type: 'danger',
				title: 'Error!',
				message: 'Please set a result for all selections',
				timeout: 5
			});
			return;
		}

		sending = true;
		SportcastSelectionStore.updateManualResults(selection, selectionResults)
			.then(() => {
				notify({
					type: 'success',
					title: selection.name,
					message: 'Sportscast selection result saved',
					timeout: 3
				});
				open = false;
				dispatch('resulted');
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to save manual sportscast selection result',
					timeout: 5
				});
			})
			.finally(() => (sending = false));
	}

	const changeUnsetStatuses = (newStatus) => {
		for (let i in sgmSelections) {
			sgmSelections[i].status = parseInt(newStatus);
		}
		sgmSelections = sgmSelections;
	};
</script>

{#if $ACLStore && ACLStore.granted('sport_events') && open}
	<Modal on:close={() => (open = false)} className="md:w-1/2 mx-2 md:mx-auto overflow-y-auto">
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Manual Result SGM Selection</h2>
		<div class="pt-2 font-semibold text-center">{eventName}</div>
		<div class="pt-1 px-6 flex justify-end w-full">
			<div class="flex justify-end w-1/2">
				<SelectInput className="w-1/5" on:change={(evt) => changeUnsetStatuses(evt.target.value)} value={false}>
					<option disabled selected value={false}>None</option>
					<option value={SportSelectionStatus.Lost}>Lost</option>
					<option value={SportSelectionStatus.Win}>Win</option>
					<option value={SportSelectionStatus.Void}>Void</option>
				</SelectInput>
			</div>
		</div>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<div class="grid grid-cols-2 mb-4">
				<div class="col-start-1 py-2 pl-2 font-semibold border-b text-left bg-gray-200">Selection</div>
				<div class="py-2 pr-2 font-semibold border-b text-right bg-gray-200">Result</div>
				{#each sgmSelections as sgm_selection, sgm_selection_index (sgm_selection_index + '_' + sgm_selection.id)}
					<div class="flex col-start-1 px-2 pt-5 text-left border-b border-row-separator content-center">
						{sgm_selection.name}
					</div>
					<div class="flex items-center justify-end px-2 py-2 space-x-2 text-right border-b border-row-separator">
						<SelectInput
							className="w-1/5"
							bind:value={sgm_selection.status}
							name={`${sgm_selection.id}-status`}
							errors={errors && errors[sgm_selection.id + '-status']}
						>
							<option disabled value={false}>None</option>
							<option value={SportSelectionStatus.Lost}>Lost</option>
							<option value={SportSelectionStatus.Win}>Win</option>
							<option value={SportSelectionStatus.Void}>Void</option>
						</SelectInput>
					</div>
				{/each}
			</div>
			<LoadingButton on:click={saveResults} loading={sending} className="mb-4 btn btn-primary-action"
				>Save Results
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click|preventDefault={() => (open = false)}> Cancel</button>
		</div>
	</Modal>
{/if}
